import { FunctionComponent, useEffect, useMemo } from 'react'
import Router from '@/router'
import '@/styles/reset.css'
import '@/styles/global.css'
import {
  ThemeProvider,
  ToastContainer as OldToastContainer,
} from '@conexasaude/hero'
import { ToastContainer } from '@conexasaude/hero-web'
import { Global } from '@emotion/react'
import globalStyles from '@/styles/global'
import '@/styles/bootstrap-grid-no-compress.css'
import '@/styles/bootstrap-utilities-compressed.css'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { MedicalSpecialitiesProvider } from '@/modules/MedicalSpecialities/contexts/MedicalSpecialitiesContext'
import { ModalProvider } from '@/components/Modal/contexts/ModalContext'
import { AttendanceProvider } from '@/modules/Attendance/contexts/AttendanceContex'
import { CheckoutProvider } from '@/modules/Checkout/contexts/CheckoutContext'
import ScreeningProvider from '@/modules/Screening/contexts/screeningContext'
import { RealtimeAttendanceProvider } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { FirebaseProvider } from '@/modules/Firebase/contexts/FirebaseContext'
import RealtimeAttendance from '@/modules/RealtimeAttendance/pages'
import { Zendesk } from '@/components/Zendesk'
import { PatientRegistrationProvider } from './modules/PatientRegistration/contexts/PatientRegistrationContext'
import { BenefitsProvider } from './modules/Benefits/contexts/BenefitsContext'
import { ConciergeAps } from '@/modules/HealthTeams/components/ConciergeAps'
import { RenderIf } from './components/RenderIf'
import { useAuthContext } from './modules/Auth/contexts/AuthContext'
import { GroupConsultationProvider } from './modules/MyCalls/contexts/consultationGroupContext'
import { startBrazeSdk } from './services/braze'
import { ChatLayer } from './components/ChatLayer'
import useHeight from './utils/useHeight'
// Needed for hero-web toast
import 'animate.css'

const App: FunctionComponent = () => {
  const { theme } = useThemeGeneratorContext()
  const { user } = useAuthContext()
  const height = useHeight()
  const styles = globalStyles({ height })
  const hasHealthTeamEnabled = useMemo(() => user?.isHealthTeam, [user])

  useEffect(() => {
    if (!user) return

    startBrazeSdk(user)
  }, [user])

  return (
    <ThemeProvider theme={theme}>
      <MedicalSpecialitiesProvider>
        <AttendanceProvider>
          <PatientRegistrationProvider>
            <CheckoutProvider>
              <ModalProvider>
                <RealtimeAttendanceProvider>
                  <ScreeningProvider>
                    <FirebaseProvider>
                      <BenefitsProvider>
                        <GroupConsultationProvider>
                          <div css={[styles.mainContainer, styles.typography]}>
                            <Router />
                            <RealtimeAttendance />
                            <div id="modal-root" />
                            <RenderIf condition={hasHealthTeamEnabled}>
                              <ConciergeAps />
                            </RenderIf>
                            <Zendesk />
                            <ChatLayer />
                          </div>
                        </GroupConsultationProvider>
                      </BenefitsProvider>
                    </FirebaseProvider>
                  </ScreeningProvider>
                </RealtimeAttendanceProvider>
              </ModalProvider>
            </CheckoutProvider>
            <OldToastContainer
              theme="dark"
              autoClose={5000}
              position="top-right"
            />
            <ToastContainer position="top-right" />
            <Global styles={styles.global} />
          </PatientRegistrationProvider>
        </AttendanceProvider>
      </MedicalSpecialitiesProvider>
    </ThemeProvider>
  )
}

export default App
